import type {
  Environment,
  EnvQueryParams,
  EnvironmentForm,
  ApiResponse,
  Project,
  ProjectForm,
  ProjectQueryParams,
  DeleteEnvParams,
  IDParams,
} from "../types";
import NProgress from "./progress";

// const HOST = "http://47.243.231.237:8080/api/deployment";
// const HOST = "http://192.168.8.7:8080";
const HOST = window.location.origin + "/api/deployment";

// 封装请求函数
async function request<T>(url: string, options: RequestInit = {}): Promise<T> {
  NProgress.start();
  const token = localStorage.getItem("access_token");
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
  };

  if (token) {
    headers["Authorization"] = token;
  }
  const response = await fetch(`${HOST}${url}`, {
    headers,
    ...options,
  });
  NProgress.done();
  if (response.status === 403) {
    localStorage.removeItem("access_token");
    window.location.reload();
    return Promise.reject("登录已过期，请重新登录");
  }

  const data = await response.json();
  if (data.code !== 0) {
    return Promise.reject(data.errMsg || "请求失败");
  }

  return data as T;
}

// 验证口令
export async function verifyToken(token: string): Promise<{ auth: string }> {
  const response = await request<ApiResponse<{ auth: string }>>("/auth", {
    method: "POST",
    body: JSON.stringify({ token }),
  });
  return response.data;
}

// 获取环境列表
export async function getEnvironments(
  params?: EnvQueryParams,
): Promise<Environment[]> {
  const response = await request<ApiResponse<Environment[]>>("/env/find", {
    method: "POST",
    body: JSON.stringify(params || {}),
  });

  return response.data;
}

// 新增环境
export async function addEnvironment(
  data: EnvironmentForm,
): Promise<Environment> {
  const response = await request<ApiResponse<Environment>>("/env/add", {
    method: "POST",
    body: JSON.stringify(data),
  });

  return response.data;
}

// 编辑环境
export async function updateEnvironment(
  data: Environment,
): Promise<Environment> {
  const response = await request<ApiResponse<Environment>>("/env/update", {
    method: "POST",
    body: JSON.stringify(data),
  });

  return response.data;
}

// 删除环境
export async function deleteEnvironment(id: number): Promise<void> {
  await request<ApiResponse<void>>("/destroy/env", {
    method: "POST",
    body: JSON.stringify({ id } as DeleteEnvParams),
  });
}

// 部署环境
export async function deployEnv(id: number): Promise<void> {
  await request<ApiResponse<void>>("/deploy/env", {
    method: "POST",
    body: JSON.stringify({ id } as IDParams),
  });
}

// 获取项目列表 (by envID)
export async function getProjects(envID: number): Promise<Project[]> {
  const response = await request<ApiResponse<Project[]>>("/project/find", {
    method: "POST",
    body: JSON.stringify({ envID } as ProjectQueryParams),
  });

  return response.data;
}

// 新增项目
export async function addProject(data: ProjectForm): Promise<Project> {
  const response = await request<ApiResponse<Project>>("/project/add", {
    method: "POST",
    body: JSON.stringify(data),
  });

  return response.data;
}

// 修改项目信息
export async function updateProject(
  data: Partial<Project> & { id: number },
): Promise<Project> {
  const response = await request<ApiResponse<Project>>("/project/update", {
    method: "POST",
    body: JSON.stringify(data),
  });

  return response.data;
}

// 项目详情
export async function detailProjectApi(
  data: Partial<Project> & { id: number },
): Promise<Project> {
  const response = await request<ApiResponse<Project>>("/project/detail", {
    method: "POST",
    body: JSON.stringify(data),
  });

  return response.data;
}

// 销毁项目
export async function destroyProject(id: number): Promise<void> {
  await request<ApiResponse<void>>("/destroy/project", {
    method: "POST",
    body: JSON.stringify({ id } as IDParams),
  });
}

// 部署项目
export async function deployProject(id: number): Promise<void> {
  await request<ApiResponse<void>>("/deploy/project", {
    method: "POST",
    body: JSON.stringify({ id } as IDParams),
  });
}
